<template>
  <div>
    <!-- <AppHeader /> -->
    <v-divider></v-divider>
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg2 hidden-md-and-down>
        <v-navigation-drawer
          class="fixedSidebar"
          v-model="sideNav"
          clipped
          overlay-color="yellow"
          width="100%"
          height="100vh"
          permanent
          color="white"
        >
          <v-layout wrap>
            <v-flex xs12 text-left py-2 text-uppercase align-self-center>
              <!-- <v-list dense v-for="(main, i) in appMenu" :key="i"> -->
                <v-layout wrap>
                  <v-flex xs12 py-2>
                   


 <v-navigation-drawer height="450px" absolute permanent>
            <v-layout class="menufont1" wrap justify-center pa-3>
              <v-flex xs12>
                <v-list dense nav>
                <v-list-item class="py-2"
                  v-for="(main, i) in appMenu" :key="i"
                  link
                  :to="main.route"
                >

                  <v-list-item-content>
                    <v-list-item-title style="font-size:15px;" class="sbold">{{ main.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              </v-flex>
            </v-layout>
          </v-navigation-drawer>


                    <!-- <v-list-group
                   
                      v-if="main._id !== '60ed5bd072b4ca543c57424d'"
                      no-action
                      :value="false"
                      active-class="activated"
                    >
                      <template v-slot:activator>
                        <v-list-item-title
                          style="
                            font-size: 14px;
                            letter-spacing: 2px;
                            color: white;
                            cursor: pointer;
                            font-family: syneb;
                          "
                          >{{ main.name }}</v-list-item-title
                        >
                      </template>
                      <v-flex xs12 py-2 px-4>
                        <div style="border-bottom: 1px dotted black"></div>
                      </v-flex>
                      <template v-for="(sub, i) in main.subMenu">
                        <v-flex xs12 text-left pl-4 :key="i">
                          <v-layout wrap justify-center>
                            <v-flex xs12>
                              <router-link :to="sub.route" style="text-decoration:none">
                                <span
                                  :style="
                                    $route.path == sub.route
                                      ? {
                                          'font-family': 'syneb',
                                          'font-size': ' 16px',
                                          
                                        }
                                      : {
                                          'font-family': 'syneb',
                                          'font-size': ' 13px',
                                        }
                                  "
                                  style="
                                    color: black;
                                    letter-spacing: 3px;
                                    cursor: pointer;
                                  "
                                >
                                  {{ sub.name }}
                                </span>
                              </router-link>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 py-2 px-4 :key="sub._d">
                          <div style="border-bottom: 1px solid black"></div>
                        </v-flex>
                      </template>
                    </v-list-group> -->
                    <!-- <v-list-group v-else> -->
                    <!-- <v-list dark dense v-else>
                      <template v-for="(item, i) in admin">
                        <v-flex xs12 pl-4 align-self-center text-left :key="i">
                          <v-layout wrap justify-center>
                            <v-flex xs12>
                              <router-link :to="item.route">
                                <span
                                  :style="
                                    $route.path == item.route
                                      ? {
                                          'font-family': 'poppinsbold',
                                          'font-size': ' 16px',
                                        }
                                      : {
                                          'font-family': 'poppinssemibold',
                                          'font-size': ' 13px',
                                        }
                                  "
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    letter-spacing: 3px;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </span>
                              </router-link>
                            </v-flex>
                          </v-layout>
                        </v-flex> -->
                        <!-- <v-flex xs12 py-2 px-4 :key="i">
                      <div style="border-bottom: 1px solid #ffffff25"></div>
                    </v-flex> -->
                      <!-- </template>
                    </v-list> -->
                  </v-flex>
                </v-layout>
                <!-- </v-list-group> -->
              <!-- </v-list> -->
            </v-flex>
          </v-layout>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg10 pt-12 pt-lg-0>
        <v-layout
          wrap
          justify-center
          :style="
            $route.name == 'Dashboard'
              ? 'background-color: #FFFFFF'
              : 'background-color: #fff9c4'
          "
        >
          <v-flex xs12 pa-0>
            <v-card
              min-height="100vh"
              :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
              :flat="$route.name == 'Dashboard' ? true : false"
            >
              <v-layout wrap justify-center>
                <v-flex xs12 pa-4>
                  <router-view :key="$route.fullPath"> </router-view>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import AppHeader from "./../layout/AppHeader";
export default {
  components: {
    // AppHeader,
  },
  data() {
    return {
      sideNav: true,
      admin: [{ name: "ADMINS", route: "/Admins" }],
      menus: [
        {
          name: "Dashboard",
          route: "/admin",
         
        },

        {
          name: "User List",
          route: "/userlist",
         
        },
        {
          name: "Privacy Policy",
          route: "/privacy",
        
        },
        {
          name: "Reports",
          route: "/reports",
        
        },
      ],
      // menus: [
      //   {
      //     name: "Dashboard",
      //     subMenu: [
      //       {
      //         name: "board",
      //         route: "/admin",
      //       },
      //     ],
      //   },

      //   {
      //     name: "User List",
      //     subMenu: [
      //       {
      //         name: "User List",
      //         route: "/userlist",
      //       },
      //     ],
      //   },
      //   {
      //     name: "Privacy Policy",
      //     subMenu: [
      //       {
      //         name: "Privacy Policy",
      //         route: "/privacy",
      //       },
      //     ],
      //   },
      // ],
    };
  },
  computed: {
    appType() {
      return this.$store.state.userType;
    },
    appMenu() {
      // console.log("menus", store.state.menus);
      return this.menus;
    },
    navItems() {
      if (this.appType == "subadmin") return this.userNavItemsSubAdmin;
      else if (this.appType == "programadmin")
        return this.userNavItemsProgramAdmin;
      else if (this.appType == "staticcontentadmin")
        return this.userNavItemsStaticAdmin;
      else if (this.appType == "accountsadmin")
        return this.userNavItemsAccountsAdmin;
      else return this.userNavItems;
    },
  },
};
</script>
<style>
@media only screen and (min-device-width: 767px) {
  .fixedSidebar {
    /* position: fixed; */

    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 50;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-width: 640px) {
  .fixedSidebar {
    display: none !important;
  }
}
/* .activated { */
.activated {
  color: white !important;
}
/* } */
</style>
